import EncodingRoot from './Encoding.root';

export default {
    Component: EncodingRoot,
};
